import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

export const LoadingSpinner = ({ spinning = true, height = "90vh" }) => {
    return (
        <Spin
            spinning={spinning}
            indicator={<LoadingOutlined spin />}
            size="large"
            style={{
                height: height,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        />
    );
};